import { Directive, Input, TemplateRef, ViewContainerRef, ChangeDetectorRef, Renderer2, ElementRef } from '@angular/core';

import { Flag } from './feature-toggle.types';

/**
 * @description Practically an *ngIf, just to better differentiate the features in the template code.
 */
@Directive({
    selector: '[ipcFeatureToggle]'
})
export class IpcFeatureToggleDirective {

    private featureName: string;

    @Input() public ipcFeatureToggle: Flag;

    @Input() public ipcFeatureToggleElse: TemplateRef<any> | null;

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private renderer: Renderer2,
        private elementRef: ElementRef
    ) { }

    public ngOnInit(): void {
      if (typeof this.ipcFeatureToggle.isEnabled !== 'function') {
        console.warn(`FeatureToggleDirective: The provided feature is not a valid feature flag object.`, this.ipcFeatureToggle);
        return;
      }

      this.featureName = this.ipcFeatureToggle.name;
      this.renderFeature(this.ipcFeatureToggle.isEnabled());
    }

    private renderFeature(isEnabled: boolean) {
        const template = isEnabled ? this.templateRef : this.ipcFeatureToggleElse;

        if (!isEnabled && this.viewContainer.length === 0 && !template) {
            return;
        }

        if (this.viewContainer.length === 0) {
            this.viewContainer.clear();
            this.viewContainer.createEmbeddedView(template);

            const element: HTMLElement = this.elementRef && this.elementRef.nativeElement;
            const featureMarker = `${!isEnabled && template ? 'NOT ' : ''}${this.featureName}`;
            if (element.nextElementSibling) {
                this.renderer.setAttribute(element.nextElementSibling, 'data-feature', featureMarker);
            }
        } else {
            this.viewContainer?.clear();
        }
    }
}
